import { render, staticRenderFns } from "./salesRecord.vue?vue&type=template&id=dafc1d18&scoped=true"
import script from "./salesRecord.vue?vue&type=script&lang=js"
export * from "./salesRecord.vue?vue&type=script&lang=js"
import style0 from "./salesRecord.vue?vue&type=style&index=0&id=dafc1d18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafc1d18",
  null
  
)

export default component.exports